import { Component, Input } from '@angular/core'
import { BookingDocket } from '../domain/BookingDocket'

@Component({
    selector: 'app-menu-choices-progress',
    standalone: true,
    templateUrl: './menu-choices-progress.component.html'
})
export class MenuChoicesProgressComponent {
    @Input() docket: BookingDocket | null = null
    @Input() totalCovers = 0

    get completedCovers(): number {
        return this.docket ? this.docket.completedCovers(this.totalCovers) : 0
    }

    get progressPercent(): number {
        return this.docket ? this.docket.progressPercent(this.totalCovers) : 0
    }
}
